export enum CallDirection {
  INBOUND = "INBOUND",
  OUTBOUND = "OUTBOUND",
}

export enum CallStatus {
  ONGOING = "ONGOING",
  TRANSFERRED = "TRANSFERRED",
  DISCONNECTED = "DISCONNECTED",
  FAILED = "FAILED",
  FINISHED = "FINISHED",
  VOICEMAIL = "VOICEMAIL",
}

export enum CallType {
  MANUAL = "MANUAL",
  AI = "AI",
}
